const EMPTY_LOGO_URL_VALUES = new Set([
  'null',
  'undefined',
  'none',
  'n/a',
  'na',
  '[object object]',
]);

export function normalizeLogoUrl(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  const logoUrl = value.trim();
  if (!logoUrl || EMPTY_LOGO_URL_VALUES.has(logoUrl.toLowerCase())) {
    return '';
  }

  return logoUrl;
}
